module.exports = __webpack_public_path__ + "static/media/logout.2704876d.svg";